import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lms/src/components/not-found.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
